<template>
    <div id="whatsappcontactlist">
        <div>
            <b-button @click="refresh" class="m-2">Refresh</b-button>
            <a-input-search
                v-model="searchText"
                @input="onSearch($event.target.value)"
                :placeholder="$t('message.startFilter')"
                class="search-input"
            />
        </div>
        <a-table
            :columns="cols"
            :dataSource="getOnlyPersonelContacts"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            :key="'vtable-' + renderCount"
            :locale="{
                emptyText: $t('message.noContactFound'),
            }"
            rowKey="id"
            size="small"
            class="custom-table"
        >
            <div slot="avatarSlot" slot-scope="data, item" class="p-1">
                <a-avatar
                    :size="30"
                    shape="square"
                    style="background-color: #3899ff; border-radius: 7px !important"
                    :username="item.name"
                    :src="$_.get(item, 'profilePicThumbObj.eurl')"
                >
                    {{ item.name.substr(0, 1).toLocaleUpperCase() }}
                </a-avatar>
            </div>

            <div slot="action" slot-scope="data, item">
                <div class="d-flex justify-content-end" style="margin-right: -10px !important">
                    <md-button
                        id="joinChat"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                            theme: isDarkMode ? 'light-border' : 'google',
                        }"
                        :content="$t('wp.startChatWp')"
                        data-v-step="16"
                        @click="startChat(item.id)"
                    >
                        {{$t('wp.startChatWp')}}
                        <md-icon style="color: #06e576; font-size: 12px"> whatsapp </md-icon>

                    </md-button>
                </div>
            </div>
        </a-table>
    </div>
</template>

<script>
import { log2 } from "../utils/log2";
import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { mapGetters, mapState } from "vuex";
import { tableSorter } from "../utils/utils";
import Fuse from "fuse.js";
import SYSTEM_PUBSUB from "../utils/systemPubSub";
import { first, filter, timeout } from "rxjs/operators";

const log = log2("VisitorList");
export default {
    name: "WhatsappContactList",
    components: {},
    props: {},
    data() {
        return {
            lastPersonelContacts: [],
            searchText: "",
            renderCount: 0,
            currentSort: {
                columnKey: "connectionTime",
                order: "ascend",
            },
            pagination: {
                defaultPageSize:15,
                hideOnSinglePage:true,
                pageSizeOptions:['10','15','20','50','100'],
                showQuickJumper:true,
                showSizeChanger:true,
            },
            cols: [
                {
                    key: "profilePicThumbObj",
                    dataIndex: "profilePicThumbObj.eurl",
                    title: this.$t("message.profile"),
                    ...tableSorter("profilePicThumbObj", "string", this.currentSort),
                    scopedSlots: { customRender: "avatarSlot" },
                },
                {
                    key: "name",
                    dataIndex: "name",
                    title: this.$t("message.name"),
                    ...tableSorter("name", "string", this.currentSort),
                    scopedSlots: { customRender: "name" },
                },
                {
                    key: "id",
                    dataIndex: `id`,
                    title: this.$t("message.number"),
                    ...tableSorter("id", "string", this.currentSort),
                    scopedSlots: { customRender: "id" },
                },
                {
                    title: "Action",
                    key: "operation",
                    scopedSlots: { customRender: "action" },
                    width: "100px",
                },
            ],
            loading: true,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            contacts: (state) => state.whatsapp.contacts,
        }),
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
            myActiveConversations: "chat/getMyActiveConversations",
        }),
        getOnlyPersonelContacts() {
            log("getOnlyPersonelContacts running");
            if(!!this.contacts){
                setTimeout(() => {console.log("Page is refreshing...");this.loading=false}, 500);
                let tempContacts = this.contacts;
                log("tempContacts", tempContacts);
                let onlyPersonelContacts = tempContacts.filter((x) => x.id.includes("@c")&& !!x.name);
                log("onlyPersonelContacts", onlyPersonelContacts);
                this.lastPersonelContacts = onlyPersonelContacts;
                log("this.lastPersonelContacts", this.lastPersonelContacts);
                for (let i = 0; i < onlyPersonelContacts.length; i++) {
                    this.lastPersonelContacts[i].id = onlyPersonelContacts[i].id.slice(0, -5);
                }
                this.lastPersonelContacts = this.getFilteredRows(this.lastPersonelContacts);
                return this.lastPersonelContacts;
            }
            else{
                this.loading=false
                return
            }
        },
    },
    mounted() {
        log("mounted");
        sendSocketMessage("whatsapp get-contacts", { siteId: this.site._id });
    },
    methods: {
        startChat(whatsappNumber) {
            log("startChat", { whatsappNumber });
            const maybeJoinedChat = this.myActiveConversations.find(
                (x) => x.whatsappNumber === whatsappNumber + "@c.us"
            );
            if (!!maybeJoinedChat) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.OPEN_CHAT, {
                    conversationId: maybeJoinedChat._id,
                });
            } else {
                const hide = this.$message.loading(this.$t("wp.chatStartingWait"), 0);

                socketMessageStream
                    .pipe(
                        filter((x) => x.cmd === "join_chat_immediately"),
                        timeout(5000),
                        first()
                    )
                    .toPromise()
                    .then((x) => {
                        this.$message.success(this.$t("wp.chatStarted"));
                    })
                    .catch((err) => {
                        this.$message.error(this.$t("wp.chatNotStarted"));
                    })
                    .finally(() => {
                        hide();
                    });
                sendSocketMessage("user start-chat", {
                    siteId: this.site._id,
                    userId: this.user._id,
                    whatsappNumber: whatsappNumber + "@c.us",
                });
            }
        },
        refresh() {
            this.loading=true;
            setTimeout(() => {console.log("Page is refreshing...");this.loading=false}, 500);
            sendSocketMessage("whatsapp get-contacts", { siteId: this.site._id });
            this.pagination.current = 1;
        },
        handleTableChange(pagination, filters, sorter) {
            this.loading=true;
            setTimeout(() => {console.log("pagination*", pagination);this.loading=false}, 370);
            const pager = { ...this.pagination };
            pager.current = pagination.current;
            this.pagination = pager;
        },
        getFilteredRows(getContacts = this.contacts) {
            log("=this.contacts", getContacts);
            let fuzzySearch = new Fuse(getContacts, { keys: ["name", "id"] });
            const filteredRows =
                this.searchText.length > 0 ? fuzzySearch.search(this.searchText).map((x) => x.item) : getContacts;
            log("filteredRow", filteredRows);
            return filteredRows;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
            this.refresh();
        },
    },
};
</script>

<style lang="scss" scoped>
.custom-button {
    max-width: 18px;
    min-width: 18px;
    max-height: 18px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-button svg {
    width: 14px;
    height: 14px;
}

.custom-table {
    background-color: #ffffff;
    border-radius: 6px;
    padding: 10px 20px;
    overflow-y: auto;
}
#joinChat {
    font-size: 12px;
    border-radius: 4px;
    border: solid 1px #92e317;
    background-color: white;

    &:hover {
        border: solid 2px #92e317;
    }
}

</style>
